import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { SelectedSolutionSession } from '@backrs_ui/grow-ui/src/redux/coachingDashboard/memberSolutionSession';

export const useAgentContext = (session: SelectedSolutionSession | null) => {
  useRegisterAgentContext(
    session
      ? {
          kind: 'entity',
          description:
            "The student's solution session output the user is currently viewing. The output itself is not in this context, so fetch it with the get-solution-session tool using this solution_session_type before answering anything about it -- including a request to summarize what is on screen.",
          data: {
            solution_session_type: session.sessionType,
            solution_session_name: session.title,
          },
        }
      : null,
  );
};
